import { useMemo } from "react";

import { useLocalization } from "@fluent/react";

import { LIVE_LEDGER_METHOD_QUERY_KEY } from "../../constants";
import { useMultiSelectFilter } from "../../hooks/useMultiSelectFilter";

import MultiSelectFilterPanel from "./MultiSelectFilterPanel";

export interface MethodFilterPanelProps {
  close: () => void;
  remove: () => void;
  onApply: () => void;
}

const METHOD_VALUES = ["ach", "card", "check", "internal_transfer"] as const;

const MethodFilterPanel = ({
  close,
  remove,
  onApply,
}: MethodFilterPanelProps) => {
  const { l10n } = useLocalization();

  const options = useMemo(
    () =>
      METHOD_VALUES.map((value) => ({
        value,
        label: l10n.getString(`live-ledger-filter-method-option-${value}`),
      })),
    [l10n]
  );

  const { selectedValues, setSelectedValues } = useMultiSelectFilter({
    queryKey: LIVE_LEDGER_METHOD_QUERY_KEY,
    validValues: METHOD_VALUES as unknown as string[],
  });

  return (
    <MultiSelectFilterPanel
      options={options}
      selectedValues={selectedValues}
      setSelectedValues={setSelectedValues}
      close={close}
      remove={remove}
      onApply={onApply}
      searchLabel={l10n.getString("live-ledger-filter-method-search")}
      emptyLabel={l10n.getString("live-ledger-filter-method-empty")}
      applyLabel={l10n.getString("live-ledger-filter-method-apply")}
      removeLabel={l10n.getString("live-ledger-filter-method-remove")}
      testIdPrefix="ledger-method-filter"
    />
  );
};

export default MethodFilterPanel;
